import { ClassConstructor } from '@portal-core/util/types/class-constructor.type';
import { Observable } from 'rxjs';

export interface IResettable {
  reset$(): Observable<unknown>;
}

interface ResettableDecorator {
  (): ((constructor: ClassConstructor) => void);
  resettables: IResettable[];
}

// Use Object.assign to add the resettables array to the Resettable function with strict typing for the function and added property
export const Resettable: ResettableDecorator = Object.assign(() => {
  return function (constructor: ClassConstructor) {
    if (typeof constructor.prototype.reset$ !== 'function') {
      throw new Error(`${constructor.name} is using @Resettable but does not implement IResettable.`);
    }

    (constructor as ClassConstructor & { mcResettable: boolean }).mcResettable = true;
    Resettable.resettables.push(constructor as unknown as IResettable); // TODO: write this so the cast to unknown is unnecessary
  };
}, {
  resettables: []
});
